/* ===========================================================================
   product-card.js
   ---------------------------------------------------------------------------
   Behaviour for every <product-card>.
   - Runs once per card (data-pc-ready flag).
   - Can be called again for cards injected later (infinite scroll).
   =========================================================================== */

(function () {
  /**
   * Initialise a NodeList/array of product-card elements.
   * If no argument is passed we auto-select every card that has not been
   * initialised yet.
   */
  function initProductCards(
    cards = document.querySelectorAll('.product-card:not([data-pc-ready])')
  ) {
    if (!cards.length) return;

    /* ---------- 1. Card-level setup ----------------------------------- */
    cards.forEach(function (card) {
      card.dataset.pcReady = '1';                 // guard
      const slider   = card.querySelector('.product-card__slider');
      if (!slider) return;                        // safety guard

      /* 1-a: flags ------------------------------------------------------ */
      let   isLookbook = card.dataset.lookbook === 'true';
      const isHover3   = card.dataset.hover3   === 'true';
      const isHover2 = card.dataset.hover2 === 'true';
      const isWoman = card.classList.contains('is_woman');
      if (window.location.pathname === '/') isLookbook = false;
      
      /* NUEVO: Detectar si es un producto Bicycle y si estamos en su página */
      const handle = card.getAttribute('handle') || '';
      const isBicycleProduct = handle.includes('bicycle') || handle.includes('playing-cards');
      const isOnBicyclePage = window.location.pathname.includes('/collections/cold-culture-x-bicycle');
      const shouldDisableSwipe = isBicycleProduct && !isOnBicyclePage;

      /* 1-b: DOM refs & state ------------------------------------------- */
      const slides      = slider.querySelectorAll('.product-card__slide');
      const prevBtn     = card.querySelector('.product-card__slider-prev');
      const nextBtn     = card.querySelector('.product-card__slider-next');
      const dotsCont    = card.querySelector('.product-card__slider-dots');
      const dots        = dotsCont ? dotsCont.querySelectorAll('.product-card__slider-dot') : null;

      let currentIndex  = 0;
      const total       = slides.length;
      const maxDots     = 3;
      const dotsShown   = Math.min(maxDots, total);
      let hovered       = false;

      /* 1-c: helpers ---------------------------------------------------- */
      const preload = i => {
        i = (i + total) % total;
        const img = slides[i]?.querySelector('img');
        if (img && !img.complete) new Image().src = img.src;
      };
      const show = idx => {
        idx = (idx + total) % total;
        currentIndex = idx;
        slides.forEach((s, i) => (s.style.display = i === idx ? 'block' : 'none'));
        if (dots) dots.forEach((d, i) => d.classList.toggle('is-active', i === (idx % dotsShown)));
        preload(idx + 1);
      };
      const next = () => show(currentIndex + 1);
      const prev = () => show(currentIndex - 1);

      /* 1-d: UI events -------------------------------------------------- */
      nextBtn?.addEventListener('click', e => { e.preventDefault(); next(); });
      prevBtn?.addEventListener('click', e => { e.preventDefault(); prev(); });

      /* swipe (mobile) - MODIFICADO PARA BICYCLE */
      if (!shouldDisableSwipe) {
        // Solo añadir swipe si NO es un producto Bicycle fuera de su página
        let sx = null;
        slider.addEventListener('touchstart',  e => { sx = e.changedTouches[0].screenX; }, false);
        slider.addEventListener('touchend',    e => {
          const dx = e.changedTouches[0].screenX - sx;
          if (dx >  50) prev();
          if (dx < -50) next();
        }, false);
      } else {
        // Para productos Bicycle fuera de su página, prevenir cualquier interacción de swipe
        slider.addEventListener('touchstart', e => { e.stopPropagation(); }, true);
        slider.addEventListener('touchend', e => { e.stopPropagation(); }, true);
        slider.addEventListener('touchmove', e => { e.stopPropagation(); }, true);
      }

      /* hover (desktop) - MANTENER FUNCIONANDO PARA TODOS */
      const mediaWrap = card.querySelector('.product-card__media-wrapper');
      const desktop   = cb => { if (window.innerWidth > 768) cb(); };

      // Hover funciona normal para TODOS los productos incluyendo Bicycle
      mediaWrap?.addEventListener('mouseenter', () => desktop(() => {
        if (isLookbook) {
          if (currentIndex === 2 && total) { show(0); hovered = true; }
        } else if (mediaWrap.closest(".is_woman")) {
          show(0); hovered = true;
        } else if (isHover2) {
          if (currentIndex === 0 && total > 1) { show(1); hovered = true; }
        } else if (isHover3) {
          if (currentIndex === 0) { show(total > 2 ? 2 : 1); hovered = true; }
        } else if (currentIndex === 0 && total > 1) {
          show(1); hovered = true;
        }
      }));

      mediaWrap?.addEventListener('mouseleave', () => desktop(() => {
        if (!hovered) return;
        if (isLookbook)          show(total > 2 ? 2 : 0);
        if (mediaWrap.closest(".is_woman")) {
          const imageWoman = card.querySelector('.product-image--women');
          let inx = parseInt(imageWoman.getAttribute('index')) || 0;
          show(inx);
          currentIndex  = 0;
        }
        else                     show(0);
        hovered = false;
      }));

      /* respond to collection view toggle */
      // document.addEventListener('viewToggleChanged', e => {
      //   const isProductView = e.detail.isProductView;
      //   if (isProductView)             show(0);
      //   else if (total > 2)            show(2);
      //   else if (total > 1)            show(1);
      // });

      /* 1-e: initial frame --------------------------------------------- */
      (function firstFrame() {
        if (!isWoman) {
        if (isLookbook) {
          show(total > 2 ? 2 : total > 1 ? 1 : 0);
        } else {
          const toolbar   = document.querySelector('.collection-toolbar');
          const handle    = toolbar?.getAttribute('data-collection-handle') || 'default';
          const key       = 'isProductView_' + handle;
          const gridView  = !(localStorage.getItem(key) === 'false');
          if (gridView)                show(0);
          else if (total > 2)          show(2);
          else if (total > 1)          show(1);
        }
        }
        slider.style.visibility = 'visible';
      })();
    });

    /* ---------- 2. Batch-level niceties ------------------------------- */

    /* fade-in cascade */
    (function fadeIn(list) {
      list = Array.from(list);
      let i = 0;
      function step() {
        if (i >= list.length) return;
        const c   = list[i++];
        c.style.opacity    = '0';
        c.style.transition = 'opacity 0.3s ease-out';
        const img = c.querySelector('.product-card__slide img');
        const go  = () => { c.style.opacity = '1'; setTimeout(step, 100); };
        if (!img || img.complete) go(); else img.addEventListener('load', go, { once: true });
      }
      step();
    })(cards);

    /* eager-preload 3rd image of hover3 cards (desktop) */
    if (window.innerWidth > 768) {
      cards.forEach(card => {
        if (card.dataset.hover2 === 'true') {
          const thirdImg = card.querySelectorAll('.product-card__slide img')[2];
          if (thirdImg && !thirdImg.complete) new Image().src = thirdImg.src;
        }
        
        if (card.dataset.hover3 === 'true') {
          const thirdImg = card.querySelectorAll('.product-card__slide img')[3];
          if (thirdImg && !thirdImg.complete) new Image().src = thirdImg.src;
        }
      });
    }
  }

  /* ---------------------------------------------------------------------
     Expose & bootstrap
  --------------------------------------------------------------------- */
  window.initProductCards = initProductCards;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductCards());
  } else {
    initProductCards();                       // page already loaded
  }
  
  /* ---------------------------------------------------------------------
     NUEVO: Protección adicional para productos Bicycle
  --------------------------------------------------------------------- */
  // Re-verificar periódicamente que los productos Bicycle mantengan el estado correcto
  if (!window.location.pathname.includes('/collections/cold-culture-x-bicycle')) {
    setInterval(() => {
      const bicycleProducts = document.querySelectorAll('[handle*="bicycle"], [handle*="playing-cards"]');
      bicycleProducts.forEach(card => {
        if (!card.dataset.bicycleProtected) {
          card.dataset.bicycleProtected = 'true';
          const slides = card.querySelectorAll('.product-card__slide');
          const firstSlide = slides[0];
          const lastSlide = slides[slides.length - 1];
          
          // Asegurar que solo el primer slide esté visible
          if (firstSlide && window.getComputedStyle(firstSlide).display === 'none') {
            slides.forEach((slide, i) => {
              slide.style.display = i === 0 ? 'block' : 'none';
            });
          }
        }
      });
    }, 2000); // Verificar cada 2 segundos
  }
})();